import { useState } from 'react'
import { loadStripe, type Stripe } from '@stripe/stripe-js'
import { PAYMENT_PROVIDERS } from 'constants/paymentSettingShared.constants'
import { Nullable } from 'types/helpers'

interface UseStripePromiseReturn {
  stripePromise: Nullable<Promise<Stripe>>
  ablefyConnectPromise: Nullable<Promise<Stripe>>
  initStripePromise: (pubKey: string, provider: string) => Promise<Stripe>
  getPromiseByProvider: (provider: string) => Promise<Nullable<Stripe>>
}

export default function useStripePromise(): UseStripePromiseReturn {
  const [stripePromise, setStripePromise] = useState<Promise<Stripe> | null>(null)
  const [ablefyConnectPromise, setAblefyConnectPromise] = useState<Promise<Stripe> | null>(null)
  const [stripeKey, setStripeKey] = useState<string>('')
  const [ablefyKey, setAblefyKey] = useState<string>('')

  const initStripePromise = (pubKey: string, provider: string) => {
    if (provider === PAYMENT_PROVIDERS.elopageConnect) {
      if (ablefyKey === pubKey && ablefyConnectPromise) {
        return ablefyConnectPromise
      }

      const promise = loadStripe(pubKey)
      setAblefyConnectPromise(promise)
      setAblefyKey(pubKey)
      return promise
    }

    if (provider === PAYMENT_PROVIDERS.stripe) {
      if (stripeKey === pubKey && stripePromise) {
        return stripePromise
      }

      const promise = loadStripe(pubKey)
      setStripePromise(promise)
      setStripeKey(pubKey)
      return promise
    }

    return Promise.reject(null)
  }

  const getPromiseByProvider = (provider: string) => {
    if (provider === PAYMENT_PROVIDERS.elopageConnect) {
      return ablefyConnectPromise
    }

    if (provider === PAYMENT_PROVIDERS.stripe) {
      return stripePromise
    }

    return Promise.resolve(null)
  }

  return {
    stripePromise,
    ablefyConnectPromise,
    initStripePromise,
    getPromiseByProvider,
  }
}
